
export default function Services() {
  const services = [
    {
      icon: 'ri-tools-line',
      title: 'Manutenção Predial',
      description: 'Serviços completos de manutenção preventiva e corretiva para manter seu prédio sempre em perfeito estado.',
      features: ['Elétrica', 'Hidráulica', 'Pintura', 'Alvenaria']
    },
    {
      icon: 'ri-leaf-line',
      title: 'Jardinagem e Paisagismo',
      description: 'Cuidamos das áreas verdes com profissionalismo, criando ambientes bonitos e bem cuidados.',
      features: ['Poda', 'Plantio', 'Irrigação', 'Design Paisagístico']
    },
    {
      icon: 'ri-shield-check-line',
      title: 'Segurança e Portaria',
      description: 'Serviços de segurança 24h com profissionais treinados para garantir a tranquilidade dos moradores.',
      features: ['Portaria 24h', 'Monitoramento', 'Controle de Acesso', 'Rondas']
    },
    {
      icon: 'ri-brush-line',
      title: 'Limpeza Especializada',
      description: 'Limpeza profissional de todas as áreas comuns e serviços especializados de conservação.',
      features: ['Áreas Comuns', 'Vidros', 'Piscinas', 'Garagens']
    },
    {
      icon: 'ri-settings-3-line',
      title: 'Administração Predial',
      description: 'Gestão completa do condomínio com transparência e eficiência administrativa.',
      features: ['Gestão Financeira', 'Assembleias', 'Relatórios', 'Consultoria']
    },
    {
      icon: 'ri-hammer-line',
      title: 'Reformas e Melhorias',
      description: 'Projetos de reforma e modernização para valorizar seu patrimônio.',
      features: ['Reformas', 'Modernização', 'Projetos', 'Execução']
    }
  ];

  return (
    <section id="servicos" className="py-20 bg-gray-50">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
            Nossos Serviços
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Oferecemos uma gama completa de serviços especializados para prédios e condomínios, 
            sempre com foco na qualidade e satisfação do cliente.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {services.map((service, index) => (
            <div 
              key={index}
              className="bg-white rounded-2xl p-8 shadow-lg hover:shadow-xl transition-all duration-300 transform hover:-translate-y-2"
            >
              <div className="w-16 h-16 bg-orange-100 rounded-full flex items-center justify-center mb-6">
                <i className={`${service.icon} text-2xl text-orange-600`}></i>
              </div>
              
              <h3 className="text-2xl font-bold text-gray-900 mb-4">
                {service.title}
              </h3>
              
              <p className="text-gray-600 mb-6 leading-relaxed">
                {service.description}
              </p>
              
              <div className="space-y-2">
                {service.features.map((feature, featureIndex) => (
                  <div key={featureIndex} className="flex items-center">
                    <i className="ri-check-line text-orange-600 mr-3"></i>
                    <span className="text-gray-700">{feature}</span>
                  </div>
                ))}
              </div>
              
              <button className="mt-6 w-full bg-orange-600 text-white py-3 rounded-full hover:bg-orange-700 transition-colors cursor-pointer whitespace-nowrap">
                Saiba Mais
              </button>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
